var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatureMain2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.441 39.994 39.505 27l-1.021-1.021-11.907 11.905-6.192-6.124-1.085 1.089zM15.827 47.07a10.776 10.776 0 0 1-7.961-3.3A10.946 10.946 0 0 1 4.6 35.775a11.166 11.166 0 0 1 3.266-7.927 10.269 10.269 0 0 1 7.893-3.368 14.745 14.745 0 0 1 4.933-9.9 14.934 14.934 0 0 1 10.376-3.98 14.469 14.469 0 0 1 10.751 4.525 15.055 15.055 0 0 1 4.423 10.921v4.014h2.177a8.474 8.474 0 0 1 6.4 2.313A8.086 8.086 0 0 1 57.4 38.5a8.48 8.48 0 0 1-8.505 8.573z",
    transform: "translate(1.4 3.4)",
    style: {
      fill: "#fff"
    },
    "data-name": "\\uADF8\\uB8F9 163566"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureMain2);
export default __webpack_public_path__ + "static/media/feature-main-2.193d4794d4af1fb0b5dd02274fdf82e5.svg";
export { ForwardRef as ReactComponent };